"use client";

import dynamic from "next/dynamic";

const GeneratorView = dynamic(
    () => import("@/components/generator-view").then((m) => ({ default: m.GeneratorView })),
    { ssr: false },
);

export default function VideoGenerationPage() {
    return (
        <GeneratorView
            defaultMode="video"
            hideHeader
            className="h-[calc(100dvh-64px-64px-env(safe-area-inset-bottom))] md:h-[calc(100dvh-64px)] pb-0"
        />
    );
}
